<div [ngClass]="{'metrics-container': true, 'hidden': metrics.length == 0}">
  <div class="left-container">
    <div class="circle">
      <img [src]="'images/exclamation-circle.png' | assetVersion" alt="">
    </div>
    <span>Browsi Insights are based on:</span>
  </div>
  <div class="right-container">
    <ng-container *ngFor="let metric of metrics; let last = last">
      <div class="metrics-badge">
        <div class="main-text">{{ metric.value | shortNumber }}</div>
        <div class="sub-text">{{ metric.name }}</div>
      </div>
      <img *ngIf="!last" [src]="'images/star.png' | assetVersion" alt="">
    </ng-container>
  </div>
</div>